<template>
  <div class="tabs_content">
    <section>
      <div class="status search">
        <div class="field_left">
          <h2 v-translate>Služby</h2>
        </div>
      </div>
      <table class="vypis vypis_detail">
        <thead>
        <tr v-if="services.length > 0">
          <th>Název služby</th>
          <th>Operátor</th>
        </tr>
        </thead>

        <tbody v-if="!loading">
        <tr v-for="service in services" :key="service.id">
          <td>
            <entity-link :id="service.id" type="service">{{ service.name }}</entity-link>
          </td>
          <td>
            <entity-link :id="service.id_operator" type="operator">{{ service.operator_name }}</entity-link>
          </td>
        </tr>
        <tr v-if="services.length === 0">
          <td colspan="2">{{ $gettext('Nebyly nalezeny žádné služby.') }}</td>
        </tr>
        </tbody>
      </table>
    </section>
  </div>
</template>

<script>

import links from "../../../mixins/links";
import EntityLink from "../../../common/EntityLink.vue";

export default {
  name: "VodPackageServices",
  props: {
    entity: Object
  },
  components: {EntityLink},
  mixins: [links],
  data() {
    return {
      loading: false,
      services: [],
    }
  },
  created(ServiceService) {
    this.serviceService = ServiceService
    this.loading = true
    this.serviceService.getEntities({ vodPackageId: this.entity.id }).then(data => {
      this.services = data['services']
      this.loading = false
    });
  },
  methods: {}
}
</script>



// WEBPACK FOOTER //
// src/components/views/vodPackages/detail/Services.vue